const MONTHS_IN_YEAR = 12;
const MONTHS_TO_DISPLAY = 6;
const CURRENT_DATE = new Date();
const MARKER_RADIUS = 12;
const CANADIAN_AVERAGE = 30100000;

export { MONTHS_IN_YEAR, MONTHS_TO_DISPLAY, CURRENT_DATE, MARKER_RADIUS, CANADIAN_AVERAGE };
